import connectWithStrava from '../assets/strava/btn_strava_connect_with_orange.svg';
import styles from './StravaConnectButton.module.css';

export function StravaConnectButton({ onClick, busy = false }: { onClick: () => void; busy?: boolean }) {
  return (
    <button type="button" className={styles.button} onClick={onClick} disabled={busy} aria-label="Connect with Strava">
      <img src={connectWithStrava} alt="" height={48} />
    </button>
  );
}
